import { api } from "../api";

export async function awaitJob(
  jobId: string, 
  options = {
    maxAttempts: 60,
    intervalMs: 1000,
  }
): Promise<any> {
  let attempts = 0;

  while (attempts < options.maxAttempts) {
    try {
      const response = await api.getJobStatus(jobId);
      
      if(response.data?.status === "completed"){
        return response.data?.response;
      } else if(response.data?.status === "failed"){
        throw new Error(response.data?.message)
      }

      await new Promise(resolve => setTimeout(resolve, options.intervalMs));
      attempts++;
      
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      throw new Error(`Failed to check job status: ${errorMessage}`);
    }
  }

  throw new Error(`Job timed out after ${options.maxAttempts} attempts`);
}